import { ComputedRef, computed, useContext } from '@nuxtjs/composition-api';
import { Locale, isLocale } from '~/types/locale';

export const useLocale = (): ComputedRef<Locale> => {
  const { i18n } = useContext();
  return computed(() => (isLocale(i18n.locale) ? i18n.locale : 'au'));
};
